import { Bold, Heading2, Italic, Link, List, Quote } from 'lucide-react'

import type { FormatAction } from '../editor'

const tools: Array<{ action: FormatAction; label: string; icon: typeof Bold }> = [
  { action: 'heading', label: '二级标题', icon: Heading2 },
  { action: 'bold', label: '粗体', icon: Bold },
  { action: 'italic', label: '斜体', icon: Italic },
  { action: 'list', label: '项目列表', icon: List },
  { action: 'quote', label: '引用', icon: Quote },
  { action: 'link', label: '链接', icon: Link },
]

export function MarkdownToolbar({ onFormat }: { onFormat: (action: FormatAction) => void }) {
  return (
    <div className="markdown-toolbar" role="toolbar" aria-label="Markdown 格式">
      {tools.map(({ action, label, icon: Icon }) => (
        <button key={action} type="button" onClick={() => onFormat(action)} aria-label={label} title={label}>
          <Icon size={17} />
        </button>
      ))}
    </div>
  )
}
